<template>
  <vue-scroll class="page-gallery">
    <router-view></router-view>
  </vue-scroll>
</template>

<script>
export default {
  name: "Gallery"
};
</script>

<style lang="scss" scoped>
.el-row {
  margin-bottom: 20px;

  &:last-child {
    margin-bottom: 0;
  }
}
</style>
